import React from "react";
import Page from "./components/Page";
import Header from "./components/Header";

export default function App() {
  return (
    <>
      <Header />
      <Page />
    </>
  );
}
